import React from 'react';
import Icon from '@pushpay/icon';

const SuccessIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.945 7.594l-4.938 6.701-3.139-2.512a1.043 1.043 0 00-1.302 1.628l3.986 3.188c.457.358 1.119.278 1.477-.18l.012-.016 5.583-7.572a1.043 1.043 0 00-1.679-1.237zM12 2C6.478 2 2 6.478 2 12c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10-.006-5.52-4.48-9.994-10-10zm0 18.333a8.333 8.333 0 110-16.666A8.333 8.333 0 0120.333 12 8.343 8.343 0 0112 20.333z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

export default SuccessIcon;